/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Domain } from "./Domain";
import { Context } from "./Context";
import { EventAttributes } from "./EventAttributes";
import { Origin } from "./Origin";
export const BaseEvent = core.serialization.object({
    domain: Domain,
    context: Context,
    attributes: EventAttributes.optional(),
    callbackUrl: core.serialization.string().optional(),
    dataUrl: core.serialization.string().optional(),
    target: core.serialization.string().optional(),
    origin: Origin.optional(),
    namespaces: core.serialization.list(core.serialization.string()).optional(),
});
